import { from, of } from "rxjs";
import { ofType, combineEpics } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { parseExperimentTemplates } from "../utils/TemplateSelectionUtils.js";
import { loadExperimentTemplatesActionTypes, loadedExperimentTemplates, loadingExperimentTemplates, loadExperimentExtensionActionTypes, loadedExperimentExtensions, loadingExperimentExtensions } from "../components/ExperimentTemplateSelector/ExperimentTemplateSelector.ducks.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import MdsDataplaneResources from "@ane/exp-data/lib/resources/MdsDataplaneResource";
import MasterDataConstants from "@ane/exp-data/lib/constants/FeatureDataConstants";
import { AsyncRequestStatus } from "@ane/core/lib/models";
const getExperimentTemplatesEpic = (action$) => {
  return action$.pipe(
    ofType(loadExperimentTemplatesActionTypes.LOAD),
    mergeMap((v) => {
      var _a;
      console.log("log: workspaceId1: " + (v == null ? void 0 : v.workspaceId));
      const workspaceId = EnvironmentService.getWorkspaceIdOrDefault(v.workspaceId);
      console.log("log: workspaceId2: " + workspaceId);
      const mg = v.managementGroup || "";
      const getExperimentationGroup = from(MdsDataplaneResources.getExperimentationGroup(workspaceId, mg)).pipe(
        mergeMap((eg) => {
          const getExperimentTemplates = from(
            MdsDataplaneResources.getConfigWithType({
              workspaceId,
              experimentationGroup: eg,
              section: MasterDataConstants.experimentTemplates
            })
          ).pipe(
            mergeMap((r) => {
              var _a2;
              const parsed = parseExperimentTemplates(r);
              return of(loadedExperimentTemplates((_a2 = v.managementGroup) != null ? _a2 : "", { data: parsed, isLoading: false, error: "" }));
            })
          );
          return getExperimentTemplates;
        })
      );
      const act = loadingExperimentTemplates((_a = v.managementGroup) != null ? _a : "");
      return from([getExperimentationGroup, from([act])]).pipe(mergeMap((x) => x));
    })
  );
};
const getExperimentExtensionsEpic = (action$) => {
  return action$.pipe(
    ofType(loadExperimentExtensionActionTypes.LOAD),
    mergeMap((v) => {
      var _a;
      const workspaceId = EnvironmentService.getWorkspaceIdOrDefault(v.workspaceId);
      const mg = v.managementGroup || "";
      const getExperimentationGroup = from(MdsDataplaneResources.getExperimentationGroup(workspaceId, mg)).pipe(
        mergeMap((eg) => {
          const getExperimentTemplates = from(
            MdsDataplaneResources.getConfigWithType({
              workspaceId,
              experimentationGroup: eg,
              section: MasterDataConstants.experimentExtensions
            })
          ).pipe(
            mergeMap((r) => {
              var _a2;
              return of(
                loadedExperimentExtensions((_a2 = v.managementGroup) != null ? _a2 : "", { data: r, status: AsyncRequestStatus.Completed, error: "" })
              );
            })
          );
          return getExperimentTemplates;
        })
      );
      const act = loadingExperimentExtensions((_a = v.managementGroup) != null ? _a : "");
      return from([getExperimentationGroup, from([act])]).pipe(mergeMap((x) => x));
    })
  );
};
const templateSelectionEpics = combineEpics(getExperimentTemplatesEpic, getExperimentExtensionsEpic);
export {
  templateSelectionEpics as default,
  getExperimentExtensionsEpic,
  getExperimentTemplatesEpic
};
//# sourceMappingURL=TemplateSelectionEpic.js.map
